import React, { useState, useEffect } from "react";

const Podcasts = ({ playPodcast, currentPodcast }) => {
  const [selectedTopic, setSelectedTopic] = useState("");
  const [podcasts, setPodcasts] = useState([]);

  useEffect(() => {
    // Simulate fetching podcasts from an API
    const fetchPodcasts = async () => {
      const data = [
        {
          name: "The Internal Audit Playbook",
          topic: "Internal Audits",
          thumbnail: "/images/playbook.png",
          trackUrl: "/audio/audit_playbook.mp3",
          artist: "Audit Guru",
          isPodcastOfTheDay: false, // This is set by the backend
        },
        {
          name: "Internal Audit Planning Discussion Between an Auditor and a Client",
          topic: "Internal Audits",
          thumbnail: "/images/interview.jpg",
          trackUrl: "/audio/audio_planning.mp3",
          artist: "Audit Guru",
          isPodcastOfTheDay: true,
        },
        {
          name: "Compliance Chronicles",
          topic: "Compliance",
          thumbnail: "/images/podcast-thumbnail-3.jpg",
          trackUrl: "/audio/compliance-chronicles.mp3",
          artist: "Compliance Wizard",
          isPodcastOfTheDay: false,
        },
      ];
      setPodcasts(data);
    };

    fetchPodcasts();
  }, []);

  const filteredPodcasts = podcasts.filter(
    (podcast) => !selectedTopic || podcast.topic === selectedTopic
  );

  const isPlayingPodcast = (podcast) =>
    currentPodcast && currentPodcast.name === podcast.name;

  const podcastOfTheDay = podcasts.find((podcast) => podcast.isPodcastOfTheDay);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Podcasts</h2>

      {/* Podcast of the Day Section */}
      {podcastOfTheDay && (
        <div className="bg-blue-100 rounded-lg p-6 mb-8 shadow-md">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Podcast of the Day</h3>
          <div className="flex flex-col sm:flex-row items-center">
            <div
              className="h-40 w-40 sm:h-60 sm:w-60 rounded-md mb-4 sm:mb-0 sm:mr-6"
              style={{
                backgroundImage: `url(${podcastOfTheDay.thumbnail})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
            <div>
              <h4 className="text-lg font-semibold text-blue-600">
                {podcastOfTheDay.name}
              </h4>
              <p className="text-gray-700">{podcastOfTheDay.artist}</p>
              <button
                className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md"
                onClick={() => playPodcast(podcastOfTheDay)}
              >
                Play
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Filter Section */}
      <div className="mb-6">
        <label htmlFor="podcast-topic-filter" className="font-medium text-gray-600">
          Filter by Topic
        </label>
        <select
          id="podcast-topic-filter"
          className="w-full mt-2 p-2 border rounded-md"
          value={selectedTopic}
          onChange={(e) => setSelectedTopic(e.target.value)}
        >
          <option value="">All Topics</option>
          {["Internal Audits", "Risk Management", "Compliance"].map((topic, index) => (
            <option key={index} value={topic}>
              {topic}
            </option>
          ))}
        </select>
      </div>

      {/* Podcast Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredPodcasts.map((podcast, index) => (
          <div
            key={index}
            className={`bg-gray-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-md cursor-pointer transform transition-all duration-300 ${
              isPlayingPodcast(podcast)
                ? "border-2 border-blue-500 bg-blue-100 scale-105 shadow-lg"
                : ""
            }`}
          >
            <div
              className="h-40 w-full rounded-md mb-4 sm:h-48"
              style={{
                backgroundImage: `url(${podcast.thumbnail})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
            <h3
              className={`text-lg font-semibold ${
                isPlayingPodcast(podcast) ? "text-blue-600" : "text-gray-700"
              }`}
            >
              {podcast.name}
            </h3>
            <div className="mt-4">
              <button
                className="mr-2 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md"
                onClick={() => playPodcast(podcast)}
              >
                Play
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Podcasts;
